export const US_PHONE_DIGITS = 10;
/** Regex matching a fully-formatted US E.164 phone number: +1XXXXXXXXXX */
export const US_E164_PHONE_REGEX = /^\+1\d{10}$/;
/**
 * Strips all non-digit characters from a phone input and normalises it to
 * exactly 10 national digits, stripping a leading country code `1` when the
 * raw input has 11 digits.
 */
export function getPhoneDigits(value) {
    const digits = value.replace(/\D/g, "");
    if (digits.length === US_PHONE_DIGITS + 1 && digits.startsWith("1")) {
        return digits.slice(1);
    }
    return digits.slice(0, US_PHONE_DIGITS);
}
/**
 * Normalises a phone input to raw 10-digit national format, stripping
 * formatting characters, country codes, and capping at 10 digits.
 * Accepts values that start with `+1` as well as 11-digit inputs with a
 * leading `1`.
 */
export function normalizeUsPhoneNumber(value) {
    const trimmed = value.trim();
    if (trimmed.startsWith("+1")) {
        // Strip the '+1' prefix then pull digits
        return getPhoneDigits(trimmed.slice(2));
    }
    return getPhoneDigits(trimmed);
}
/** Returns a validation result for a valid 10-digit US phone number. */
export function isValidUsPhoneNumber(value) {
    const normalized = normalizeUsPhoneNumber(value);
    if (normalized.length !== US_PHONE_DIGITS) {
        return { ok: false, reason: "Mobile phone number must be a valid 10-digit US number." };
    }
    return { ok: true, value: normalized };
}
/**
 * Converts a raw or formatted phone value to US E.164 format (`+1XXXXXXXXXX`).
 * Returns an empty string when the value cannot be normalised to 10 digits.
 */
export function toUsE164Phone(value) {
    const digits = normalizeUsPhoneNumber(value);
    return digits.length === US_PHONE_DIGITS ? `+1${digits}` : "";
}
/**
 * Formats a normalised 10-digit string (or any phone input) as
 * `(XXX) XXX - XXXX` for display purposes.
 */
export function formatUsPhoneNumber(value) {
    const digits = normalizeUsPhoneNumber(value);
    if (digits.length === 0)
        return "";
    if (digits.length <= 3)
        return `(${digits}`;
    if (digits.length <= 6)
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} - ${digits.slice(6)}`;
}
